import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const AnonymousAccessSettingsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-AnonymousAccessSettingsPageRouteComponent" */ './AnonymousAccessSettingsPageRouteComponent.tsx'
		),
});

export const AnonymousAccessSettingsPageRoute = () => <AnonymousAccessSettingsPageRouteComponent />;

AnonymousAccessSettingsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'anonymousAccessSettingsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
